export default {
    default: `

    .autocomplete-editor {
        text-align: inherit;
        border-radius: 0;
        display: block;
        padding: 0;
        font-size: 0.875rem;
        line-height: 1.5;
        color: #3e515b;
        background-color: #fff;
        background-clip: padding-box;
        box-sizing: border-box;
        border: 1px solid #c2cfd6;
        height: auto;
        position: relative;
    }
    .toolbar {
        box-sizing: border-box;
        position: relative;
        height: 1.9rem;
    }

    .toolbar-list {
        box-sizing: border-box;
        list-style: none;
        height: 100%;
        padding: 0;
        margin: 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    .toolbar-list-item {
        padding: 0px 10px;
        box-sizing: border-box;
    }

    .toolbar-list-item-off {
        color: #c2cfd6 !important;
    }

    .toolbar-dashboard {
        background-color: #fff;
        border-bottom: 1px solid #c2cfd6;
        padding: 5px;
        position: absolute;
        box-sizing: border-box;
        z-index: 6;
        height: 6rem !important;
        width: 100%;
        overflow-y: scroll;
    }

    .toolbar-dashboard-btn {
        color: inherit;
        background-color: inherit;
        padding: 5px;
        padding: 2px 5px;
        white-space: nowrap;
        vertical-align: middle;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        border: 1px solid #c2cfd6;
        border-radius: 5px;
        margin: 5px;
        box-sizing: border-box;
    }


    .Medium-placeholder {
        position: absolute;
    }

    .Medium, .Medium p:first-child {
        margin-top: 0;
    }

    .Medium p {
        margin-bottom: .2rem;
    }

    .Medium div[contenteditable="false"] {
        display: inline-block;
    }

    .Medium-clear {
        background: transparent !important;
        background-color: transparent !important;
        border-color: transparent !important;
    }

    .Medium {
        position: relative;
        height: auto;
        font-size: 14px;
        width: 100%;
        padding: 10px;
        margin: 0;
        font-family: inherit;
        text-align: start;
        user-select: text;
        box-sizing: border-box;
        min-height: inherit;
        padding: 0.375rem 0.75rem !important;
    }

    .Medium-placeholder.Medium-placeholder-rich {
        width: 100% !important;
        min-width: 100% !important;
        min-height: inherit !important;
        height: auto;
        padding: 0.375rem 0.75rem !important;
    }

    .Medium ul {
        border: 1px solid #c2cfd6;
        margin: 0;
        padding: 0px;
        list-style: none;
        min-height: 29px;
        box-shadow: 0 0.125rem 0.25rem rgba(0,0,0,.075);
        display: block;
        margin-bottom: 5px;
        margin-top: 5px;
    }

    .Medium ul li {
        padding: 0 5px 3px 5px;
    }

    .Medium ul li:first-child {
        padding-top: 3px;
    }

    .autocomplete-highlight {
        margin: 0;
        padding: 3px;
        border-radius: .5rem;
        box-shadow: 0 .125rem .25rem rgba(0,0,0,.075);
        font-size: 80%;
        color: #FFF;
        display: inline-block;

    }

    .autocomplete-hide {
        display: none !important;
    }

    .autocomplete-highlight-f {
        background-color:#000000;
    }

    .autocomplete-highlight-d {
        background-color:#0765c3;
    }

    .autocomplete-highlight-v {
        background-color:#a8a9bd;
    }

    .autocomplete-highlight-m {
        background-color:#20c997;
    }

    .Medium #random {
        -webkit-user-modify: read-only;
        -moz-user-modify: read-only;
        user-modify: read-only;
    }

    .Medium #random {
        display: none;
    }

    `
}
